<app-wizard
  [prevButtonEnabled]="true"
  [nextButtonEnabled]="true"
  [prevButtonText]="prevButtonText()"
  [nextButtonText]="nextButtonText()"
  [prevButtonHasChevron]="prevButtonHasChevron()"
  [nextButtonHasChevron]="nextButtonHasChevron()"
  [items]="items()"
  (stepSelection)="onStepSelection($event)"
  (nextButtonClicked)="onNextButtonClick()"
  (prevButtonClicked)="onPreviousButtonClick()"
>
  <app-wizard-step
    stepId="form-wizard-progress-tab1"
    [stepNumber]="1"
    [isActive]="stepIndex() == 1"
    [formGroup]="statement"
  >
    <app-statement-form [formGroup]="statement" />
  </app-wizard-step>

  <app-wizard-step
    stepId="form-wizard-progress-tab2"
    [stepNumber]="2"
    [isActive]="stepIndex() == 2"
    [formGroup]="knowledgeTest"
  >
    <app-knowledge-test-form [formGroup]="knowledgeTest" />
  </app-wizard-step>
</app-wizard>
